import React from "react";
import "./StepListSelections.scoped.scss";
import { IStep, SWTypes } from "interfaces/sw/SWInterfaces";
import { Nestable, Item } from "../../sw/manage/steps/Nestable";
import dragIcon from "media/icons/dls/drag.svg";
import arrowRight from "media/icons/dls/arrow-right-3.svg";
import { useDispatch } from "react-redux";
import { addReusableCompItemChecked, removeReusableCompItemChecked, setReusableCompMode } from "store/manageSW/manageSWActions";
import useSelector from "store/useSelector";

interface IStepListSelectionsProps {
  steps: IStep[],
  ancestors: IStep[],
  isDisabled: boolean,
  swType: SWTypes,
}

const StepListSelections: React.FC<IStepListSelectionsProps> = ({
  steps,
  ancestors,
  isDisabled,
  swType
}) => {
  const dispatch = useDispatch();
  const parentOrders = ancestors.map(st => st.sortOrder);
  const {
    ReusableCompSortable,
  } = useSelector(store => store.manageSW);

  const onReorder = (items: Item[]) => {
    return true;
  }

  const confirmChange = (dragItem: Item, destinationParent: Item | null) => {
    return false;
  };

  const handleCheckBoxClick = (e: React.ChangeEvent<HTMLInputElement>, item: Item) => {
    if (e.target.checked) {
     dispatch(addReusableCompItemChecked(item));
    }
    else {
      dispatch(removeReusableCompItemChecked(item));
    }
    dispatch(setReusableCompMode(swType));
  }

  return (
    <>
    <ol
      className={!parentOrders.length
        ? "top-level"
        : ""}
    >
      <Nestable
        items={ReusableCompSortable}
        renderItem={({ item, index, collapseIcon }: any) => (
          <div
            className={`Nestable ${item.hasUnResolvedComments ? "unresolvedComments" : undefined} ${item.hasMasterStep ? "hasMasterStep" : undefined}`}

          >
            {item.isEnabled ?
              <input type="Checkbox" checked={item.checked} onChange={e => handleCheckBoxClick(e, item)}></input>
              : <input type="Checkbox" disabled checked={item.checked} onChange={e => handleCheckBoxClick(e, item)}></input>}

            {collapseIcon}{item.stepNumber ? item.stepNumber + ". " + item.text : item.text}
          </div>
        )}
        maxDepth={4}
        isStepList={false}
        renderCollapseIcon={({ isCollapsed }: any) => isCollapsed ? (
          <img
            className="icon-small"
            alt="drag"
            src={dragIcon} />
        ) : (
          <img
            className="icon-small"
            alt="drag"
            src={arrowRight} />
        )}
      />
    </ol></>
    
  );
}

export default StepListSelections;